/** Must be in sync with fleet backend equivalent enum  */
export enum EClient {
	Bearer = 'Bearer',
	application = 'application/json',
	authorizationType = 'authorization-type',
	token = 'token',
	client = 'client',
}

export enum EFParams {
	dateDesc = 'date:desc',
	dateAsc = 'date:asc',
	qm = '?',
	and = '&',
	limit = 'limit=',
	page = 'page=',
	status = 'status=',
	sort = 'sort=',
	search = 'search=',
	fromDate = 'fromDate=',
	toDate = 'toDate=',
	flightNumber = 'flightNumber[]=',
}

export enum ETrips {
	endpoint = '/trips',
	single = '/single/', // Endpoint with id: '/trips/single/{id}'
}

export enum EReservations {
	endpoint = '/reservations',
	single = '/single/', // Endpoint with id: '/reservations/single/{id}'
}

export enum ELocations {
	endpoint = '/locations',
}

export enum EDrivers {
	endpoint = '/drivers',
	single = '/single/', // Endpoint with id: '/drivers/single/{id}'
	suppliers = '/suppliers/simple',
}

export enum EVehicles {
	endpoint = '/vehicles',
	single = '/single/', // Endpoint with id: '/vehicles/single/{id}'
}

export enum ESocket {
	websocket = 'websocket',
}

export enum ESocketEvents {
	tripStatusChange = 'Trips:STATUS_CHANGE',
	tripUpdate = 'Trips:UPDATE',
	connectError = 'connect_error',
	connect = 'connect',
	disconnect = 'disconnect',
	done = 'Done',
}

export enum EEmit {
	joinRooms = 'joinRooms',
}
